/** Keep this policy aligned with shared_blueprint_text.py in the backend. */
export const MAX_BLUEPRINT_BYTES = 256 * 1024;

export function normalizeBlueprintText(body: string): string {
  // Python str.strip includes C0 separators, excludes BOM, and uses Unicode
  // whitespace. JavaScript trim has different semantics for those characters.
  const normalized = body
    .replace(/\r\n?/g, '\n')
    // eslint-disable-next-line no-control-regex -- Python str.strip intentionally includes these four separators.
    .replace(/^[\p{White_Space}\u001c-\u001f]+|[\p{White_Space}\u001c-\u001f]+$/gu, '');
  if (/[\ud800-\udfff]/u.test(normalized)) {
    throw new Error('Version blueprint must contain valid Unicode text.');
  }
  if (normalized.includes('\0')) {
    throw new Error('Version blueprint contains a null byte.');
  }
  return normalized;
}

export function blueprintTextState(body: string) {
  try {
    const normalized = normalizeBlueprintText(body);
    const bytes = new TextEncoder().encode(normalized).length;
    return {
      normalized,
      bytes,
      error:
        !normalized || bytes > MAX_BLUEPRINT_BYTES
          ? `Version blueprint must contain 1 to ${MAX_BLUEPRINT_BYTES.toLocaleString()} UTF-8 bytes.`
          : null,
    };
  } catch (error) {
    return { normalized: '', bytes: 0, error: (error as Error).message };
  }
}
